debounce = function(func, waitTime, obj) {
  clearTimeout(debounce.timeout);

  if (waitTime === null || typeof waitTime === "undefined") {
    waitTime = 1000;
  }

  debounce.timeout = setTimeout(function() {
    if (typeof obj !== "undefined") {
      func.apply(obj);
    }else{
      func();
    }
  }, waitTime);

};
